<template>
  <base-side-bar-drawer :visible="visibleFilterSideBar"
                        header-icon="filter"
                        @close="visibleFilterSideBar = false"
                        header-title="جستجوی پیشرفته">

    <template #body>
      <plate default_letter="" v-model:plate="plate_filter" @change="applyFilter" class="tw-mb-6" />

      <base-select title="محل تخلیه"
                   :loading="loadingGetFilterData"
                   v-model="filters.city_id"
                   :options="filterData?.cities"
                   icon="location"
                   @change="value => applyFilter({ city_id: value })"
                   class="tw-mb-6" />

      <base-select title="انتخاب کارخانه"
                   :loading="loadingGetFilterData"
                   v-model="filters.factory"
                   :options="filterData?.factories"
                   icon="factory"
                   @change="value => applyFilter({ factory: value })"
                   class="tw-mb-6" />

      <base-date-picker title="تاریخ بارگیری"
                        :range="true"
                        @change="value => applyFilter({ date_loaded: value})"
                        v-model="filters.date_loaded"
                        class="tw-mb-6" />

      <base-date-picker title="تاریخ تخلیه"
                        :range="true"
                        @change="value => applyFilter({ date_discharge: value})"
                        v-model="filters.date_discharge"
                        class="tw-mb-6" />

      <input-ayandeh
        v-model:value="filters.number_bar"
        placeholder="شماره بارنامه"
        icon-on-input="search"
        @stopTyping="value => applyFilter({ number_bar: value})"
        dir="rtl"
      />
    </template>
    <template #footer>
      <new-btn variant="outline"
               :disabled="active_advance_filter_desktop === 0"
                color="primary"
                class="tw-w-full"
                @click="removeAdvanceFilterDesktop">
        حذف فیلترها
      </new-btn>
    </template>
  </base-side-bar-drawer>

  <div class="tw-h-auto">
    <div
      class="tw-w-full tw-h-auto tw-hidden md:tw-flex tw-sticky tw-top-[113px] tw-items-center tw-justify-between tw-bg-white tw-z-[9] tw-px-6 tw-pt-6 tw-pb-5">
      <div>
        <h3 class="tw-font-bold tw-text-blue-dark-500 tw-mb-0 tw-text-base">{{ tableName || "" }}</h3>
        <div class="tw-flex tw-items-center tw-gap-1 tw-text-blue-dark-200 tw-mt-1 tw-text-tiny">
          <span>تعداد کل</span>
          <loading-spinner :show="true" v-if="loading" size="sm"/>
          <span v-else>{{ total }}</span>
        </div>
      </div>
      <div class="tw-flex tw-justify-between tw-gap-4">
        <input-ayandeh
          v-model:value="filters.search"
          placeholder="جستجوی سریع"
          icon-on-input="search"
          dir="rtl"
        />
        <new-btn class="tw-relative"
                 variant="outline"
                 color="primary"
                 @click="toggleCentralFilter">
          <base-icon icon="circle-bold"
                     v-if="active_advance_filter_desktop"
                     size="10"
                     class="tw-text-red-600 tw-absolute tw-right-2 tw-top-2" />
          <base-icon icon="filter-bold" v-if="visibleFilterSideBar" />
          <base-icon icon="filter" v-else />
        </new-btn>
        <new-btn variant="outline"
                 color="primary">
          <base-icon icon="download-offline" />
        </new-btn>
      </div>
    </div>
    <v-table :loading="props.loading"
             :can-load-more="canLoadMore"
             @load-more="emit('load_more')"
             :is-empty="!props.payment_ables.length"
             empty-label="هیچ پرداختنی برای نمایش وجود ندارد!">
      <template #header>
        <tr>
          <th>ردیف</th>
          <th>
            شناسه
            <FilterOnThTable @applyFilter="applyFilter"
                             :inputs="[
                                { type: 'number', label: 'شناسه', placeholder: 'شناسه پرداختنی را وارد کنید', name: 'payment_able_id', direction: 'ltr', filter_values: filters},
                             ]"/>
          </th>
          <th>
            تاریخ ایجاد
            <FilterOnThTable @applyFilter="applyFilter"
                             :inputs="[
                                { type: 'date', label: 'تاریخ ایجاد', placeholder: 'تاریخ ایجاد', name: 'date_created', filter_values: filters},
                             ]" />
          </th>
          <th>
            بابت
            <FilterOnThTable @applyFilter="applyFilter"
                             :inputs="[
                                { type: 'select', options: options_pay_for, label: 'بابت', placeholder: 'انتخاب بابت', name: 'pay_for', filter_values: filters},
                             ]"/>
          </th>
          <th>
            شناسه بار
            <FilterOnThTable @applyFilter="applyFilter"
                             :inputs="[
                                { type: 'number', label: 'شناسه بار', placeholder: 'شناسه بار را وارد کنید', name: 'order_id', direction: 'ltr', filter_values: filters},
                             ]"/>

          </th>
          <th>
            بستانکار
            <FilterOnThTable @applyFilter="applyFilter"
                             :inputs="[
                                { type: 'plate', name: 'plate', filter_values: filters},
                             ]"/>
          </th>
          <th>
            مبلغ
            <currency :parentheses="true"/>
            <FilterOnThTable @applyFilter="applyFilter"
                             :inputs="[
                                { type: 'amount', label: 'مبلغ', placeholder: 'مبلغ را وارد کنید', name: 'amount', direction: 'ltr', filter_values: filters},
                             ]"/>
          </th>
          <th>
            وضعیت
            <FilterOnThTable @applyFilter="applyFilter"
                             :inputs="[
                                { type: 'select', options: [{label: 'پرداخت شده', value: 'payed'},{label: 'در انتظار پرداخت', value: 'waiting_for_pay'},{label: 'لغو شده', value: 'canceled'}], label: 'بابت', placeholder: 'انتخاب بابت', name: 'status', filter_values: filters},
                             ]"/>
          </th>
          <th>گزینه ها</th>
        </tr>
      </template>
      <template #body>
        <tr v-for="(item, key) in props.payment_ables"
            :key="item.id"
            :class="[ payment_able_selected?.id === item.id && 'is-selected']">
          <td class="number_if_rows">
            <span>{{ (key+1).toString().padStart(2, '0') }}</span>
          </td>
          <td @click="showModalDetail(item)">
            {{ item.id }}
          </td>
          <td @click="showModalDetail(item)">
            {{ to_jalali(item.created_at) }}
          </td>
          <td @click="showModalDetail(item)">
            <base-icon v-if="item.pay_for === 'order_to_payment'" icon="history-edu" class="tw-align-middle tw-ml-2" />
            <base-icon v-else icon="money-bag" class="tw-align-middle tw-ml-2" />
            {{ getPayForTitlePaymentAble(item) }}
          </td>
          <td @click="showModalDetail(item)">
            {{ item.order_id ? item.order.order_id : '-/-' }}
          </td>
          <td @click="showModalDetail(item)">
            <license-plate v-if="item.creditorable?.car_number_base !== undefined" :car="item.creditorable" size="sm"/>
            <base-animated-text v-else-if="item.creditorable?.first_name !== undefined"
                                :max-length="25"
                                :text="mixin.methods.get_fullname(item.creditorable)" />
          </td>
          <td @click="showModalDetail(item)">
            {{ toNumberFormat(item.amount) }}
            <currency class="d-inline-block d-md-none"/>
          </td>
          <td @click="showModalDetail(item)"
              :class="[
                (item.payed && !item.cancel) && '!tw-text-green-600',
                item.cancel && '!tw-text-red-600',
                ]">
            {{ item.status_title }}
          </td>
          <td @click="showModalDetail(item)">
            <base-icon icon="info" class="tw-text-primary-500 !tw-cursor-pointer"/>
          </td>
        </tr>
      </template>
    </v-table>

  </div>

  <PaymentableDetail v-model="showDetail"
                     @refresh_list="(data) => emit('refresh_data', data)"
                     v-model:payment_able_selected="payment_able_selected"
                     @close="hideModalDetail" />
</template>

<script setup>

import {ref, computed, watch, defineProps, defineEmits} from "vue";
import VTable from "@/components/base/table/VTable.vue";
import Currency from "@/components/partial/Currency.vue";
import LicensePlate from "@/components/partial/LicensePlate.vue";
import mixin from '@/mixin'
import BaseIcon from "@/components/base/BaseIcon.vue";
import PaymentableDetail from "@/components/paymentable/PaymentableDetail.vue";
import BaseAnimatedText from "@/components/base/BaseAnimatedText.vue";
import FilterOnThTable from "@/components/base/more/FilterOnThTable.vue";
import LoadingSpinner from "@/components/loading/LoadingSpinner.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";
import BaseSideBarDrawer from "@/components/base/BaseSideBarDrawer.vue";
import Plate from "@/components/partial/Plate.vue";
import { useStore } from 'vuex'
import BaseSelect from "@/components/base/select/BaseSelect.vue";
import BaseDatePicker from "@/components/base/select/BaseDatePicker.vue";
import { apiGetFilterData, getPayForTitlePaymentAble } from "@/services/paymentable/PaymentAble.js";

const store = useStore()
const tableName = ref("لیست پرداختنی ها");
const visibleFilterSideBar = ref(false)
const city_id = ref(null)
const factory_id = ref(null)
const date_loaded = ref(null)
const date_discharge = ref(null)
const number_bar = ref('')
const plate_filter = ref(null)

// State
const showDetail = ref(false)
const payment_able_selected = ref(null)
const filter_values = ref({})
const filterData = ref(null)
const loadingGetFilterData = ref(false)

// فیلد های جستجوی پیشرفته برای تشخیص فعال بودن یا غیر فعال بودن
const advance_filter_desktop = ['search','number_bar','date_discharge','date_loaded','factory','city_id','two_digits','three_digits','plate_letter','number_base'];

const props = defineProps({
  loading: { type: Boolean, default: false },
  options_pay_for: { type: Array, default: () => [] },
  payment_ables: { type: Object, required: true },
  total: { type: Number, default: 0 },
  filters: { type: Object, default: () => {} }, // for filter
  canLoadMore: {type: Boolean, default: false}
})

const emit = defineEmits(['update:filters','refresh_data','load_more'])


watch(
  () => props.filters,
  (val) => {
    filter_values.value = { ...val }
  },
  { immediate: true, deep: true }
)

// Methods

// Computed
const has_order = computed(() => props.payment_ables.filter((x) => x.order_id != null).length)


const td_count = computed(() => {
  let count = 8
  if (has_order.value) count += 3
  return count
})

const showModalDetail = (paymntable) => {
  showDetail.value = true;
  payment_able_selected.value = paymntable
}

const hideModalDetail = () => {
  payment_able_selected.value = null
}

function applyFilter(data) {

  if (data.plate) {
    const plateData = data.plate;
    // delete data.plate;
    if(plateData) {
      data = {
        ...data,
        ...plateData,
      };
    }

  } else {
    filter_values.value.number_base = null;
    filter_values.value.three_digits = null;
    filter_values.value.two_digits = null;
    filter_values.value.letter = null;
  }

  filter_values.value = {
    ...filter_values.value,
    ...data
  }
  emit('update:filters', filter_values.value)
}


function toggleCentralFilter() {
  visibleFilterSideBar.value = !visibleFilterSideBar.value
}

async function fetchFilterData() {
  try {
    loadingGetFilterData.value = true
    const response = await apiGetFilterData()
    filterData.value = response.data
  } catch (error) {
    console.error(error);
  } finally {
    loadingGetFilterData.value = false
  }
}

const active_advance_filter_desktop = computed(() => {
  return Object.entries(props.filters).filter(([key, value]) => advance_filter_desktop.some(k => key.includes(k) && !!value)).length
})

function removeAdvanceFilterDesktop() {
  let newFilters = { ...props.filters }
  advance_filter_desktop.forEach((key) => {
    Object.keys(newFilters).forEach((filterKey) => {
      if (filterKey.includes(key)) {
        delete newFilters[filterKey]
      }
    })
  })
  emit('update:filters', newFilters)
}
watch(
  () => visibleFilterSideBar.value,
  () => fetchFilterData()
)
</script>


<style scoped>

</style>
